/**
 * ============================
 * Custom Order Page 1 (モデル選択)
 * ============================
 * ・商品カードを描画
 * ・カード選択で state.productId 更新 → 「次へ」活性化
 * ・「詳細を見る」で詳細モーダル
 * ・「次へ」で state 保存 → Page 2 へ遷移
 */

(function () {
  "use strict";

  const listEl = document.getElementById("co-product-list");
  if (!listEl) return; // Page 1 以外では動かない

  const tabsEl = document.getElementById("co-category-tabs");
  const nextBtn = document.getElementById("co-next");
  const CO = window.CustomOrder;
  const products = CO.data.products || [];

  // タブの並び順は position（本番データ）で決める。
  // Liquid 側の sort はメタフィールド越しだと挙動が読めないため、
  // snippet は position をそのまま出力し、並べ替えはここで行う。
  // position を持たないダミーデータでは全て 0 になり、sort が安定なので配列順が保たれる。
  const categories = (CO.data.categories || [])
    .slice()
    .sort((a, b) => (a.position || 0) - (b.position || 0));

  const ALL_CATEGORY = "all";
  let activeCategory = ALL_CATEGORY;
  let selectedId = CO.getState().productId || null;

  // データから消えた商品 ID が localStorage に残っていることがある
  // （商品の入れ替え・is_custom_order の解除など）。放置すると「次へ」が
  // 押せてしまい、Page2 が Page1 へ戻すだけの往復になるのでここで捨てる。
  if (selectedId && !CO.getProduct(selectedId)) selectedId = null;

  // 商品が1件以上あるカテゴリだけを、categories の並び順で抽出
  function visibleCategories() {
    return categories.filter((cat) =>
      products.some((p) => p.category === cat.id)
    );
  }

  function filteredProducts() {
    if (activeCategory === ALL_CATEGORY) return products;
    return products.filter((p) => p.category === activeCategory);
  }

  function updateNextBtn() {
    if (!nextBtn) return;
    nextBtn.disabled = !selectedId;
  }

  // 描画済みカード（キーボード操作と選択状態の塗り替えに使う）
  let cardEntries = [];

  function selectCard(product) {
    selectedId = product.id;
    CO.setState({ productId: product.id });
    refreshCardStates();
    updateNextBtn();
  }

  // 選択状態とタブ順を塗り直す。radiogroup 内の Tab 到達点は1つだけ
  // （roving tabindex）＝選択済み、無ければ先頭。
  function refreshCardStates() {
    const tabStop =
      cardEntries.find((c) => c.id === selectedId) || cardEntries[0];

    cardEntries.forEach((c) => {
      const isSelected = c.id === selectedId;
      c.card.classList.toggle("is-selected", isSelected);
      c.body.setAttribute("aria-checked", isSelected ? "true" : "false");
      c.body.setAttribute("tabindex", c === tabStop ? "0" : "-1");
    });
  }

  // radiogroup の標準キー操作：矢印で移動しその場で選択、Space / Enter で選択
  function onCardKeydown(e, entry) {
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
      selectCard(entry.product);
      return;
    }

    const forward = e.key === "ArrowRight" || e.key === "ArrowDown";
    const backward = e.key === "ArrowLeft" || e.key === "ArrowUp";
    if (!forward && !backward) return;
    e.preventDefault();

    if (!cardEntries.length) return;
    const i = cardEntries.indexOf(entry);
    const next =
      cardEntries[
        (i + (forward ? 1 : -1) + cardEntries.length) % cardEntries.length
      ];
    selectCard(next.product);
    next.body.focus();
  }

  function renderTabs() {
    if (!tabsEl) return;

    const cats = visibleCategories();
    // カテゴリが1つ以下ならタブを出す意味がないので非表示
    if (cats.length <= 1) {
      tabsEl.style.display = "none";
      return;
    }

    const tabDefs = [{ id: ALL_CATEGORY, name: "すべて" }].concat(cats);
    tabsEl.innerHTML = "";

    tabDefs.forEach((cat) => {
      // role="tab" は「対応する tabpanel があり矢印キーで移動する」ことを
      // 支援技術に約束してしまう。ここは1つのリストを絞り込むトグルなので、
      // 素のボタン＋aria-pressed で表す（Tab と Enter だけで完結する）。
      const tab = document.createElement("button");
      tab.type = "button";
      tab.className = "co-tab";
      tab.textContent = cat.name;
      const isActive = cat.id === activeCategory;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-pressed", isActive ? "true" : "false");

      tab.addEventListener("click", () => {
        if (activeCategory === cat.id) return;
        activeCategory = cat.id;
        renderTabs();
        renderProducts();
      });

      tabsEl.appendChild(tab);
    });
  }

  function renderProducts() {
    listEl.innerHTML = "";
    cardEntries = [];

    // モデル選択も単一選択なので radiogroup（A-8 / NFR6）
    listEl.setAttribute("role", "radiogroup");
    listEl.setAttribute("aria-label", "モデル");

    filteredProducts().forEach((product) => {
      const card = document.createElement("div");
      card.className = "co-card";

      // 「詳細を見る」は radio の**外**に出す。role="radio" の内側にボタンを
      // 置くと支援技術からそのボタンを操作できなくなるため。
      // 管理画面由来のテキスト・URL は innerHTML に連結せず、
      // textContent / src プロパティで入れる（PRD §14 本番硬化）。
      card.innerHTML =
        '<div class="co-card__body" role="radio" tabindex="-1" aria-checked="false">' +
        (product.thumbnail
          ? '<div class="co-card__imgwrap">' +
            '<img alt="" class="co-card__img" />' +
            "</div>"
          : "") +
        '<h3 class="co-card__title"></h3>' +
        '<p class="co-card__price"></p>' +
        "</div>" +
        '<button type="button" class="co-btn-detail">詳細を見る</button>';

      const imgEl = card.querySelector(".co-card__img");
      if (imgEl) imgEl.src = product.thumbnail;
      card.querySelector(".co-card__title").textContent = product.name;
      card.querySelector(".co-card__price").textContent =
        CO.formatYen(product.price_from) + "〜";

      const entry = {
        id: product.id,
        product: product,
        card: card,
        body: card.querySelector(".co-card__body")
      };
      cardEntries.push(entry);

      card.querySelector(".co-btn-detail").addEventListener("click", () => {
        CO.openModal({
          images: product.modal_images,
          title: product.name,
          price: CO.formatYen(product.price_from) + "〜",
          description: product.description
        });
      });

      // カードのどこを押しても選択。ただし「詳細を見る」は別動作。
      card.addEventListener("click", (e) => {
        if (e.target.closest(".co-btn-detail")) return;
        selectCard(product);
      });

      entry.body.addEventListener("keydown", (e) => onCardKeydown(e, entry));

      listEl.appendChild(card);
    });

    refreshCardStates();
    updateNextBtn();
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      if (!selectedId) return;
      CO.setState({ productId: selectedId });
      window.location.href = "/pages/custom-order-detail";
    });
  }

  renderTabs();
  renderProducts();
})();
